import React, { createContext, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useGetChairperson } from '@/hooks'

const ChairpersonContext = createContext(null)

export const ChairpersonProvider = ({ children }) => {
  const location = useLocation()
  const { chairperson, setChairperson, loadingChairperson, getChairperson } =
    useGetChairperson()

  // Check if we're on a chairperson route
  const isChairpersonRoute = location.pathname.startsWith('/chairperson')

  const value = useMemo(() => {
    return {
      chairperson,
      setChairperson,
      loadingChairperson,
      getChairperson,
      isChairpersonRoute,
    }
  }, [chairperson, loadingChairperson, isChairpersonRoute])

  return (
    <ChairpersonContext.Provider value={value}>
      {children}
    </ChairpersonContext.Provider>
  )
}

export const useChairpersonContext = () => {
  const ctx = useContext(ChairpersonContext)
  if (!ctx) {
    throw new Error(
      'useChairpersonContext must be used within a ChairpersonProvider'
    )
  }
  return ctx
}

export default ChairpersonContext
